module.exports = __webpack_public_path__ + "img/google-scholar.b614bdef.svg";